import Layout from '@/Layout/index'
import Vue from 'vue'
import Router from 'vue-router'

import Login from '@/components/login'

Vue.use(Router)

// 刚登录会报错误信息，抑制一下
const originalPush = Router.prototype.push
Router.prototype.push = function push(location, onResolve, onReject) {
	if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
		return originalPush.call(this, location).catch(err => err)
}

//默认都可以进的路由表
export const routes = [{
		path: '/agreement',
		component: () => import('@/views/agreement/agreement'),
		hidden: true
	},
	{
		path: '/',
		component: Login,
		hidden: true
	}, //路径为空，进入登录页面
	{
		path: '*',
		component: () => import('@/views/errorPage/404'),
		hidden: true
	}, //用户输入错误的网址,设置错误提示，跳进404页面
]
export const homeData=[{
	path: '/home',
	name: '首页',
	redirect: '/home/index',
	meta: {
		title: '首页'
	},
	component: Layout,
	children:[{
		path: '/home/index',
		name: "首页",
		meta: {
			icon: 'el-icon-s-home',
			title: '首页',
			code: '1'
		},
		component: () => import('@/views/home/index'),
	}]
}]

//需要权限判断的路由表
export const addroutes = [{
		path: '/home',
		name: '首页',
		redirect: '/home/index',
		meta: {
			title: '首页'
		},
		component: Layout,
		children: [{
				path: '/home/index',
				name: "首页",
				meta: {
					icon: 'el-icon-s-home',
					title: '首页',
					code: '1'
				},
				component: () => import('@/views/home/index'),
			},
			{
				path: '/factoryManage',
				name: '客户管理',
				redirect: '/factoryManage/factoryList',
				meta: {
					icon: 'el-icon-s-custom',
					title: '客户管理',
					code: '2'
				},
				component: () => import('@/components/home'), //路由盒子 home （有下拉菜单、子路由的 都需要加路由盒子）
				children: [{
						path: '/factoryManage/factoryList',
						name: "客户列表",
						meta: {
							title: '客户列表',
							code: '3'
						},
						component: () => import('@/views/factoryManage/factoryList'),
					},
					{
						path: '/agreement/list',
						name: "协议列表",
						meta: {
							title: '协议列表',
							code: '4'
						},
						component: () => import('@/views/agreement/list'),
					},
					{
						path: '/factoryManage/factoryInfo', //携带参数
						name: "客户信息",
						meta: {
							title: '客户信息',
							code: '9'
						},
						hidden: true, //隐藏此选项 不在左侧导航显示
						component: () => import('@/views/factoryManage/factoryInfo'),
					},
					// {
					//   path: '/factoryManage/frp',
					//   name: "穿透信息",
					//   meta: {title: '穿透信息'},
					//   component: () => import('@/views/factoryManage/frp'),
					// },
					{
						path: '/factoryManage/version',
						name: "版本信息",
						meta: {
							title: '版本信息',
							code: '5'
						},
						component: () => import('@/views/factoryManage/version'),
					},
					// {
					//   path: '/factoryManage/versionLog',
					//   name: "版本升级记录",
					//   meta: {title: '版本升级记录'},
					//   component: () => import('@/views/factoryManage/versionLog'),
					// },
					{
						path: '/factoryManage/payLog',
						name: "续费记录",
						meta: {
							title: '续费记录',
							code: "7"
						},
						component: () => import('@/views/factoryManage/payLog'),
					},
					{
						path: '/factoryManage/register',
						name: "注册信息",
						meta: {
							title: '注册信息',
							code: "8"
						},
						component: () => import('@/views/factoryManage/register'),
					},
					{
						path: '/factoryManage/errorLogging',
						name: "错误日志",
						meta: {
							title: '错误日志',
							code: "10"
						},
						component: () => import('@/views/factoryManage/errorLogging'),
					},
				]
			},
			{
				path: '/softWare',
				name: '软件管理',
				redirect: '/softWare/softwareInfo',
				meta: {
					icon: 'el-icon-s-platform',
					title: '软件信息',
					code: '10'
				},
				component: () => import('@/components/home'), //路由盒子 home （有下拉菜单、子路由的 都需要加路由盒子）
				children: [{
						path: '/softWare/versionInfo',
						name: "版本信息",
						meta: {
							title: '版本信息',
							code: '11'
						},
						component: () => import('@/views/softWare/versionInfo'),
					},
					{
						path: '/softWare/versionType',
						name: "版本类型",
						meta: {
							title: '版本类型',
							code: '12'
						},
						component: () => import('@/views/softWare/versionType'),
					},
					{
						path: '/softWare/softwareInfo',
						name: "软件信息",
						meta: {
							title: '软件信息',
							code: '13'
						},
						component: () => import('@/views/softWare/softwareInfo'),
					}
				]
			},
			{
				path: '/pierce',
				name: '穿透管理',
				redirect: '/pierce/pierce',
				meta: {
					icon: 'el-icon-s-tools',
					title: '系统设置',
					code: '14'
				},
				component: () => import('@/components/home'), //路由盒子 home （有下拉菜单、子路由的 都需要加路由盒子）
				children: [{
						path: '/pierce/server',
						name: "穿透云主机",
						meta: {
							title: '穿透云主机',
							code: '15'
						},
						component: () => import('@/views/pierce/server/server'),
					},
					{
						path: '/pierce/node',
						name: "穿透节点",
						meta: {
							title: '穿透节点',
							code: '16'
						},
						component: () => import('@/views/pierce/node/node'),
					},
				],
			},
			{
				path: '/system',
				name: '系统设置',
				redirect: '/system/systemType',
				meta: {
					icon: 'el-icon-s-tools',
					title: '系统设置',
					code: '17'
				},
				component: () => import('@/components/home'), //路由盒子 home （有下拉菜单、子路由的 都需要加路由盒子）
				children: [{
						path: '/system/systemType',
						name: "系统类型",
						meta: {
							title: '系统类型',
							code: '18'
						},
						component: () => import('@/views/system/systemType'),
					},
					{
						path: '/system/blackList',
						name: "电脑黑名单",
						meta: {
							title: '电脑黑名单',
							code: '19'
						},
						component: () => import('@/views/system/blackList'),
					},
					{
						path: '/system/powers',
						name: '角色管理',
						meta: {
							title: '角色管理',
							code: '20'
						},
						component: () => import('@/views/system/powers')
					},
					{
						path: '/system/staffList',
						name: "员工列表",
						meta: {
							title: '员工列表',
							code: '21'
						},
						component: () => import('@/views/system/staffList'),
					},
					{
						path: '/system/batchadd',
						name: "批量录入员工",
						meta: {
							title: '批量录入员工',
							code: '23'
						},
						hidden: true, //隐藏此选项 不在左侧导航显示
						component: () => import('@/views/system/batchadd'),
					},
					// {
					// 	path: '/system/address',
					// 	name: "地址管理",
					// 	meta: {
					// 		title: '地址管理',
					// 		code: '22'
					// 	},
					// 	component: () => import('@/views/system/address'),
					// }
				]
			}
		]
	},

	// 三级标题
	// {
	//   path: '/home',
	//   name: '首页',
	//   redirect: '/home/index',
	//   meta: {title: '首页'},
	//   component: Layout,
	//   children: [{
	//       path: '/home/index',
	//       name: "首页",
	//       meta: {icon: 'el-icon-s-home',title: '首页'},
	//       component: () => import('@/views/home/index'),
	//     },
	//     {
	//       path: '/factoryManage',
	//       name: '客户信息',
	//       redirect: '/factoryManage/factoryList',
	//       meta: {icon: 'el-icon-s-home',title: '客户信息'},
	//       component: () => import('@/components/home'),  //路由盒子 home （有下拉菜单、子路由的 都需要加路由盒子）
	//       children: [{
	//           path: '/factoryManage/factoryList',
	//           name: "工厂列表",
	//           meta: {title: '工厂列表'},
	//           component: () => import('@/components/home'),
	//           redirect: '/factoryManage/factoryList/factoryList',
	//           children: [{
	//               path: '/factoryManage/factoryList/factoryList',
	//               name: "列表展示",
	//               meta: {title: '列表展示'},
	//               component: () => import('@/views/factoryManage/factoryList/factoryList'),
	//             },
	//             {
	//                 path: '/factoryManage/factoryList/factoryInfo', //携带参数
	//                 name: "工厂信息",
	//                 meta: {title: '工厂信息'},
	//                 // hidden: true, //隐藏此选项 不在左侧导航显示
	//                 component: () => import('@/views/factoryManage/factoryList/factoryInfo'),
	//               }

	//            ]
	//         }
	//        ]
	//     }
	//    ]
	// }


]

const router = new Router({
	routes
})

//展示
export default router
